if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
            this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
            this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.cart) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        // additional service on product page
        const productInfo = this.closest(".product__info-container");
        const sectionId = productInfo?.dataset.section;
        this.productAdditionalService = productInfo?.querySelector(
          `product-additional-service[data-section-id="${sectionId}"]`
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        if( this.querySelector('.loading-overlay__spinner') ){
          this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden"
          );
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        // Guard: if variant id is missing or empty the request will always
        // fail with "Invalid product" (e.g. a Swiper-cloned slide whose
        // hidden input is still disabled). Surface a clean error instead of
        // hitting the API and confusing the shopper.
        const variantId = formData.get("id");
        if (!variantId) {
          this.handleErrorMessage(
            window.cartStrings?.invalidProduct ||
              "Invalid product. Please refresh the page and try again."
          );
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.classList.remove("loading");
          if (this.querySelector(".loading-overlay__spinner")) {
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          }
          return;
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;

        //--------------------------------------------------
        // Check for selected cross-sell items, additional services, and free item
        const selectedCrossSellItems = document.querySelectorAll('.pdp_upsell_checkbox:checked');
        const hasAdditionalService =
          this.productAdditionalService &&
          this.productAdditionalService instanceof ProductAdditionalService &&
          typeof this.productAdditionalService.getItems === "function" &&
          Array.isArray(ProductAdditionalService.selectedServices) &&
          ProductAdditionalService.selectedServices.length > 0;
        
        // Check for free item from product metafields
        const freeItemVariantId = this.dataset.freeItemVariantId;
        const formQty = parseInt(formData.get("quantity"), 10) || 1;
        const mainBundleItems = this.getMainBundleCartItems(formData, formQty);

        if (
          selectedCrossSellItems.length > 0 ||
          hasAdditionalService ||
          freeItemVariantId ||
          mainBundleItems.length > 0
        ) {
          const items = [];

          // Add main product components when present, otherwise the main product
          if (mainBundleItems.length > 0) {
            items.push(...mainBundleItems);
          } else {
            const mainProductItem = {
              id: formData.get("id"),
              quantity: formQty,
            };

            const properties = {};
            for (let [key, value] of formData.entries()) {
              if (
                key.startsWith("properties[") &&
                key !== "properties[Cross-sell Price]"
              ) {
                const propertyName = key
                  .replace("properties[", "")
                  .replace("]", "");
                properties[propertyName] = value;
              }
            }
            if (Object.keys(properties).length > 0) {
              mainProductItem.properties = properties;
            }

            items.push(mainProductItem);
          }
          
          // Add free item if available (100% discount via line property)
          if (freeItemVariantId) {
            const freeItemProperties = {
              __percent_discount: "100",
            };
            const mainProductId = this.dataset.mainProductId;

            if (mainProductId) {
              freeItemProperties.__main_product = String(mainProductId);
            }

            items.push({
              id: freeItemVariantId,
              quantity: formQty,
              properties: freeItemProperties,
            });
          }
          
          // Add ALL selected cross-sell items (expand bundle components when present)
          selectedCrossSellItems.forEach((selectedCrossSell) => {
            const crossSellItems = this.getCrossSellCartItems(
              selectedCrossSell,
              formQty
            );
            items.push(...crossSellItems);
          });

          // Add additional service items if any
          if (hasAdditionalService) {
            const serviceItems = this.productAdditionalService.getItems(formData);
            if (serviceItems?.length > 0) {
              // Skip the first item if it's the main product (already added)
              const additionalItems = serviceItems.slice(1);
              items.push(...additionalItems);
            }
          }
          
          // Prepare request body with multiple items
          const bodyData = {
            items: items,
          };
          
          if (this.cart) {
            bodyData.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id);
            bodyData.sections_url = window.location.pathname;
          }

          delete config.headers["X-Requested-With"];
          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify(bodyData);
        }
        //--------------------------------------------------

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            let activeElement = document.activeElement;
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.setActiveElement(activeElement);
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
              if (
                this.productAdditionalService &&
                this.productAdditionalService instanceof
                  ProductAdditionalService &&
                typeof this.productAdditionalService.clearItems ===
                  "function" &&
                Array.isArray(ProductAdditionalService.selectedServices) &&
                ProductAdditionalService.selectedServices.length > 0
              ) {
                this.productAdditionalService.clearItems();
              }
              
              // Clear all cross-sell selections after successful add to cart
              document.querySelectorAll('.pdp_upsell_checkbox:checked').forEach((checkbox) => {
                checkbox.checked = false;
                checkbox.dispatchEvent(new Event("change", { bubbles: true }));
              });
            } else {
              if (this.closest(".header")) {
                const cartLink = document.querySelector("#cart-icon-bubble");
                if (cartLink) {
                  activeElement = cartLink;
                }
                activeElement = document.querySelector("#cart-icon-bubble");
              } else if (this.closest(".collection-product-card")) {
                const productCard = this.closest(".collection-product-card");
                const linkTitle = productCard.querySelector(".card__title > a");
                if (linkTitle) {
                  activeElement = linkTitle;
                }
              }

              this.cart.setActiveElement(activeElement);
              this.cart.renderContents(response);
              
              // Clear all cross-sell selections after successful add to cart
              document.querySelectorAll('.pdp_upsell_checkbox:checked').forEach((checkbox) => {
                checkbox.checked = false;
                checkbox.dispatchEvent(new Event("change", { bubbles: true }));
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            if( this.querySelector(".loading-overlay__spinner") ){
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            }
          });
      }

      /**
       * Build cart line items for the main product when it has
       * custom_bundle_components metafield data.
       * @param {FormData} formData
       * @param {number} formQty
       * @returns {Array<object>}
       */
      getMainBundleCartItems(formData, formQty) {
        const jsonEl = document.querySelector(
          "script[type='application/json'][data-main-bundle-components]"
        );

        if (!jsonEl) return [];

        let bundleData = null;

        try {
          bundleData = JSON.parse(jsonEl.textContent);
        } catch (error) {
          console.error("Invalid main bundle components JSON:", error);
          return [];
        }

        if (
          !bundleData ||
          !Array.isArray(bundleData.components) ||
          !bundleData.components.length
        ) {
          return [];
        }

        const selectedVariantId = String(formData.get("id") || "");
        const numericVariantId = Number(selectedVariantId);
        const variantPrices = bundleData.variantPrices || {};
        const bundlePrice = String(
          variantPrices[selectedVariantId] != null
            ? variantPrices[selectedVariantId]
            : variantPrices[numericVariantId] != null
              ? variantPrices[numericVariantId]
              : ""
        );
        const componentCount = String(
          bundleData.componentCount || bundleData.components.length
        );
        const qty = Number(formQty) || 1;

        return bundleData.components
          .filter((component) => component && component.variantId)
          .map((component) => {
            const properties = {
              __parent_bundle_item_id: selectedVariantId,
              __bundle_component: true,
              __bundle_price: bundlePrice,
              __bundle_quantity_unit: String(Number(component.quantity) || 1),
              __bundle_component_count: componentCount,
            };

            if (component.imageUrl) {
              properties.__bundle_image = String(component.imageUrl);
            }

            return {
              id: Number(component.variantId),
              quantity: (Number(component.quantity) || 1) * qty,
              properties: properties,
            };
          });
      }

      /**
       * Build cart line items for a checked upsell checkbox.
       * If the upsell has custom_bundle_components data, expand to those
       * components with the same line properties as custom-bundle-atc.
       * @param {HTMLInputElement} checkbox
       * @param {number} formQty
       * @returns {Array<object>}
       */
      getCrossSellCartItems(checkbox, formQty) {
        const crossSellVariantId = checkbox.dataset.productid;
        const qty = Number(formQty) || 1;

        if (!crossSellVariantId) return [];

        let components = [];

        try {
          const raw = checkbox.dataset.bundleComponents;
          if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) components = parsed;
          }
        } catch (error) {
          console.error("Invalid upsell bundle components JSON:", error);
        }

        if (!components.length) {
          return [
            {
              id: crossSellVariantId,
              quantity: qty,
            },
          ];
        }

        const bundlePrice = String(checkbox.dataset.productPrice || "");
        const componentCount = String(
          checkbox.dataset.bundleComponentCount || components.length
        );

        return components
          .filter((component) => component && component.variantId)
          .map((component) => {
            const properties = {
              __parent_bundle_item_id: String(crossSellVariantId),
              __bundle_component: true,
              __bundle_price: bundlePrice,
              __bundle_quantity_unit: String(Number(component.quantity) || 1),
              __bundle_component_count: componentCount,
            };

            if (component.imageUrl) {
              properties.__bundle_image = String(component.imageUrl);
            }

            return {
              id: Number(component.variantId),
              quantity: (Number(component.quantity) || 1) * qty,
              properties: properties,
            };
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
